/**
 *
 * LakaWallet_2_0
 *
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PortalTemplate from 'Components/PortalTemplate/PortalTemplateContainer';
import Helmet from 'react-helmet';
import AcgFlow from 'Components/AcgFlow';
import { Config } from 'Constants/config_env';
import { axiosInstance as axios } from 'Api';

class LakaWallet_2_0Container extends Component {
	static propTypes = {
		authRoutes: PropTypes.objectOf(
			PropTypes.arrayOf(
				PropTypes.shape({
					component: PropTypes.func.isRequired,
					routeName: PropTypes.string.isRequired,
				})
			)
		).isRequired,
		noauthRoutes: PropTypes.objectOf(
			PropTypes.arrayOf(
				PropTypes.shape({
					component: PropTypes.func.isRequired,
				})
			)
		).isRequired,
		logged: PropTypes.bool.isRequired,
		permittedRoutes: PropTypes.arrayOf(PropTypes.string).isRequired,
	};

	render() {
		const { authRoutes, noauthRoutes, permittedRoutes, logged } = this.props;

		const loggedApp = authRoutes.routes
			.filter(({ routeName }) => permittedRoutes.includes(routeName))
			.map(({ component }) => component());

		return (
			<>
				<Helmet titleTemplate='%s - React.js Nexi Architecture' defaultTitle='React.js Boilerplate'>
					<meta name='description' content='A React.js Boilerplate for Nexi architecture' />
				</Helmet>
				<BrowserRouter>
					<PortalTemplate logged={logged} permittedRoutes={permittedRoutes}>
						<Routes>
							{noauthRoutes.routes.map(({ component }) => component())}
							{logged ? (
								loggedApp
							) : (
								<Route
									path='/'
									element={
										<AcgFlow
											background='https://www.nexigroup.com/content/dam/corp/img/homepage/home-nexi-sia-merger-d.jpg'
											title='Laka Wallet 2.0'
											authUrl={Config.auth_service}
											clientId={Config.client_id}
											redirectUri={Config.redirect_uri}
											scope='openid profile email'
											needPreLoad
											forgotPassword
										/>
									}
								/>
							)}
						</Routes>
					</PortalTemplate>
				</BrowserRouter>
			</>
		);
	}
}

export default LakaWallet_2_0Container;
